import UserList from "../views/UserList.vue";

export default [
  {
    path: "/user",
    name: "UserList",
    component: UserList,
    permission: "prodegree_service.api.jiker_prodegree_admin.users.index",
    meta: {
      title: "用户列表",
      nav: {
        icon: "el-icon-user-solid",
        title: "用户列表",
      },
    },
  },
];
